export default __webpack_public_path__ + "media/images/home/living_support-acc5a4dd5c5e271161ff9c97898f8231.webp";